export default "__VITE_ASSET__DGTbhJgp__"